'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { fulfillmentRequestApi } from '@entities/fulfillment-request'
import { Button } from '@ui/base/button'
import { FieldError } from '@ui/base/field'

/**
 * Продавец закрывает заявку, когда выбрал исполнителя: новые ответы по ней больше не приходят.
 * Заявку на проверке та же кнопка отзывает — сервер закрывает её в любом состоянии, поэтому
 * меняется только подпись.
 */
export const CloseRequestButton = ({ requestId, label = 'Закрыть заявку' }: { requestId: string; label?: string }) => {
  const router = useRouter()
  const [state, setState] = useState<'idle' | 'sending' | 'failed'>('idle')

  const close = async () => {
    setState('sending')
    try {
      await fulfillmentRequestApi.close(requestId)
      router.refresh()
    } catch {
      setState('failed')
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button variant="outline" size="sm" disabled={state === 'sending'} onClick={() => void close()}>
        {state === 'sending' ? 'Закрываем…' : label}
      </Button>
      {state === 'failed' && <FieldError>Не удалось закрыть заявку</FieldError>}
    </div>
  )
}
